import * as React from 'react';
import cx from 'clsx';

import * as styles from './OnboadringLayout.css';

type TProps = {
  children: React.ReactNode;
  testId: string;
  isMobile?: boolean;
};

export const OnboardingLayout: React.FC<TProps> = ({ children, isMobile, testId }) => {
  return (
    <div data-testid={testId} className={cx(styles['container'], isMobile && styles['container_mobile'])}>
      {children}
    </div>
  );
};
